import { Group, Stack } from '@mantine/core';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAgentSpending } from '../../../api/financials-client/financials-client.hooks';
import { PageLayout } from '../../../components/page-layout/page-layout';
import { useDocumentTitle } from '../../../helpers/general-helpers';
import { useGlobalStore } from '../../../store/global-store/global-store';
import { baseWhite } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Divider } from '../../../ui-library/divider/divider';
import { Icon } from '../../../ui-library/icon/icon';
import { H2, Text } from '../../../ui-library/typography/typography';
import { MenuDrivenContainer } from '../../menu-driven-container/menu-driven-container';
import { AgenticFinancialsSpendingTable } from './agentic-financials-spending-table';

export const EditAgenticFinancialData = () => {
  useDocumentTitle('Edit Agentic Financial Data - Bloomfilter');

  const organizationId = useGlobalStore((state) => state.organization?.id);
  const navigate = useNavigate();
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const { data: agentSpending } = useAgentSpending({
    organizationId: organizationId!,
  });

  const availableYears = useMemo(() => {
    return Array.from(
      new Set([...(agentSpending?.map((spending) => spending.year) || []), new Date().getFullYear()]),
    ).sort((a, b) => b - a);
  }, [agentSpending]);

  const filteredAgentSpending = useMemo(() => {
    return agentSpending?.filter((spending) => spending.year === selectedYear);
  }, [agentSpending, selectedYear]);

  return (
    <MenuDrivenContainer
      header={
        <Group justify="flex-start" style={{ width: '100%' }}>
          <Button
            variant="secondary"
            onClick={() => navigate('/application/agentic-process')}
            radius="xl"
            size="xs"
            leftSection={<Icon name="arrow_back" color={baseWhite} size={16} />}
          >
            Back
          </Button>
          <H2>Edit Financial Data</H2>
        </Group>
      }
    >
      <PageLayout
        controlBar={null}
        sideFilters={{
          title: 'Filters',
          content: (
            <Stack>
              <Text weight="bold">Years</Text>
              <Divider />
              {(availableYears || []).map((year) => (
                <Button
                  key={year}
                  variant={selectedYear === year ? 'secondary' : 'outline'}
                  radius="xl"
                  size="sm"
                  style={{ width: '70px' }}
                  onClick={() => setSelectedYear(year)}
                >
                  {year}
                </Button>
              ))}
            </Stack>
          ),
          width: 100,
        }}
        mainSection={
          <AgenticFinancialsSpendingTable agentSpending={filteredAgentSpending || []} selectedYear={selectedYear} />
        }
      />
    </MenuDrivenContainer>
  );
};
